import { errorMsg } from '../../constants/messages';

const PackageServiceAttributesFormData = [
    {
        title: 'Service Attributes Details',
        name: 'name',
        label: 'Name',
        fieldType: {
            name: 'text',
        },
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Name', enableSort: false, allowAddRecordClick: true },
        isTableHeader: true,
        isAccordian: true,
        default: '',
    },
    {
        name: 'value',
        label: 'Value',
        fieldType: {
            name: 'text',
        },
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: ' Value' },
        isTableHeader: true,
        isAccordian: true,
        default: '',
    },
];

export { PackageServiceAttributesFormData };
